/**
 * Human labels for the shared enums — and, more importantly, the rule that no
 * screen may enumerate an enum's values itself.
 *
 * A hardcoded list of sources is what made 124 transcribed questions
 * unfilterable: the enum grew, the dropdown did not. So every picker renders
 * `<Enum>.options` from `@exam/shared` and looks its label up here, and
 * `labelFor` falls back to the raw slug — a value added upstream shows up
 * immediately, spelled plainly, instead of silently disappearing or rendering
 * blank.
 */
import type {
  Difficulty,
  QuestionSource,
  QuestionStatus,
  QuestionType,
} from "@exam/shared";

/** `pyq` is a past-year paper; `transcribed` is other real assessment material. */
export const SOURCE_LABEL: Record<QuestionSource, string> = {
  pyq: "PYQ",
  transcribed: "Transcribed",
  generated: "Generated",
  manual: "Manual",
};

export const DIFFICULTY_LABEL: Record<Difficulty, string> = {
  easy: "Easy",
  medium: "Medium",
  hard: "Hard",
};

export const STATUS_LABEL: Record<QuestionStatus, string> = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const TYPE_LABEL: Record<QuestionType, string> = {
  MCQ: "MCQ",
  MSQ: "MSQ",
  CODE: "Code",
  NAT: "NAT",
};

/** The label for a value, or the value itself if this map has not caught up. */
export function labelFor(
  map: Record<string, string>,
  value: string | null | undefined,
): string {
  if (!value) return "—";
  return map[value] ?? value;
}
